function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  width: 222,
  height: 20,
  rx: 10,
  fill: "#DADADA"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 28,
  width: 99,
  height: 20,
  rx: 10,
  fill: "#DADADA"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  y: 168,
  width: 99,
  height: 20,
  rx: 10,
  fill: "#DADADA"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 139,
  y: 28,
  width: 111,
  height: 20,
  rx: 10,
  fill: "#3C3C3C"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 137,
  y: 168,
  width: 111,
  height: 20,
  rx: 10,
  fill: "#DADADA"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 175,
  y: 140,
  width: 75,
  height: 20,
  rx: 10,
  fill: "#DADADA"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 223,
  y: 56,
  width: 29,
  height: 20,
  rx: 10,
  fill: "#DADADA"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 221,
  y: 196,
  width: 29,
  height: 20,
  rx: 10,
  fill: "#DADADA"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 84,
  width: 41,
  height: 20,
  rx: 10,
  fill: "#DADADA"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 56,
  width: 185,
  height: 20,
  rx: 10,
  fill: "#3C3C3C"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  y: 196,
  width: 185,
  height: 20,
  rx: 10,
  fill: "#DADADA"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 79,
  y: 84,
  width: 171,
  height: 20,
  rx: 10,
  fill: "#DADADA"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 112,
  width: 248,
  height: 20,
  rx: 10,
  fill: "#DADADA"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 140,
  width: 137,
  height: 20,
  rx: 10,
  fill: "#DADADA"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 10,
  r: 10,
  fill: "#DADADA"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 38,
  r: 10,
  fill: "#6D9FFF"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 178,
  r: 10,
  fill: "#DADADA"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 205,
  cy: 66,
  r: 10,
  fill: "#DADADA"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 203,
  cy: 206,
  r: 10,
  fill: "#DADADA"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 150,
  r: 10,
  fill: "#DADADA"
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 61,
  cy: 94,
  r: 10,
  fill: "#DADADA"
});

function SvgSingleVerse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 216,
    viewBox: "0 0 252 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleVerse);
export default __webpack_public_path__ + "static/media/SingleVerse.c5188055.svg";
export { ForwardRef as ReactComponent };